module.exports = __webpack_public_path__ + "static/media/arrow_right.bf3db4a5.svg";